import { useLanguage } from '../contexts/LanguageContext'
import { Globe } from 'lucide-react'

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage()

  return (
    <div className="flex items-center gap-2 bg-white/5 backdrop-blur-sm rounded-full px-3 py-2 border border-white/10">
      <Globe className="w-4 h-4 text-white/70" />
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'en'
            ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-lg'
            : 'text-white/60 hover:text-white/90'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('de')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'de'
            ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-lg'
            : 'text-white/60 hover:text-white/90'
        }`}
      >
        DE
      </button>
    </div>
  )
}

export default LanguageSwitcher
